import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { GET_ORG_CHECK_DETAILS } from './url-constants';

type GetOrgCheckEndpointSpecification = ApiEndpointSpecification;
export const GetOrgCheckEndpointSpecification: GetOrgCheckEndpointSpecification = {
    url: GET_ORG_CHECK_DETAILS,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'GetOrgCheckRequestParams',
    requestBodySchemaName: 'GetOrgCheckRequestBody',
    okResponseSchemaName: 'GetOrgCheckOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeGetOrganizationType = Helpers.makeApiRequestFn<
    Types.GetOrgCheckRequestParams,
    Types.GetOrgCheckRequestBody,
    Types.GetOrgCheckOkResponse
>(GetOrgCheckEndpointSpecification);
